import { render, staticRenderFns } from "./rcc-pagination.vue?vue&type=template&id=4c9c9533&"
import script from "./rcc-pagination.vue?vue&type=script&lang=js&"
export * from "./rcc-pagination.vue?vue&type=script&lang=js&"
import style0 from "./rcc-pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports